import React, { Fragment } from 'react';
import {
    Container,
    Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import PermissionWrapper from '../../auth/PermissionWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt, faTimes, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';

class EmployeesByTeam extends React.Component {

    constructor(props) {
        super(props);

        this.blankEmployee = {
            employeeId: 0,
            firstName: '',
            lastName: '',
            email: '',
            jobTitle: '',
            role1: '',
            role2: '',
            teamMembership: '',
            active: true,
            startDate: '',
            exitDate: '',
            location: '',
            startTime: '',
            endTime: '',
            employeeNumber: '',
            departments: '',
            timezone: '',
            clientId: 0
        }

        this.state = {
            newEmployee: { ...this.blankEmployee },
            editEmployee: { ...this.blankEmployee },
        };

    }

    checkPermission = (permission) => {
        this.props.info('EmployeesContainer.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    onChange = (e, type) => {
        this.props.log('EmployeesByTeam.js/onChange (e,type)', e, type);
        e.persist();
        let thisEmployee = (type === 'edit') ? this.state.editEmployee : this.state.newEmployee;
        switch (e.target.name) {
            case "active":
                thisEmployee[e.target.name] = !thisEmployee[e.target.name];
                break;
            case "departments":
                let id = parseInt(String(e.target.id).split('_').pop());
                let arr = thisEmployee[e.target.name] !== '' && thisEmployee[e.target.name] != null ? String(thisEmployee[e.target.name]).split(',').filter(item => item != null && item !== '').map(item => parseInt(item)) : [];
                let index = arr.findIndex(d => d === id);
                if (index === -1) {
                    arr.push(id);
                } else {
                    arr.splice(index, 1);
                }
                thisEmployee[e.target.name] = arr.join(',');
                break;
            case "jobTitle":
            case "role1":
            case "role2":
                // case "teamMembership":
                thisEmployee[e.target.name] = e.target.value === "0" ? '' : e.target.value;
                break;
            default:
                thisEmployee[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editEmployee: thisEmployee } : { newEmployee: thisEmployee };
        });
    }

    onEdit = (employeeId) => {
        this.props.log('EmployeesContainer.js/onEdit (employeeId)', employeeId);
        const employee = [...this.props.employees].filter(employee => employee.employeeId === employeeId)[0];
        this.setState(() => {
            return {
                editEmployee: {
                    'employeeId': employeeId,
                    'firstName': employee.firstName,
                    'lastName': employee.lastName,
                    'email': employee.email,
                    'jobTitle': employee.jobTitle,
                    'role1': employee.role1,
                    'role2': employee.role2,
                    'teamMembership': employee.teamMembership,
                    'active': employee.active,
                    'startDate': employee.startDate,
                    'exitDate': employee.exitDate,
                    'location': employee.location,
                    'startTime': employee.startTime,
                    'endTime': employee.endTime,
                    'employeeNumber': employee.employeeNumber,
                    'departments': employee.departments,
                    'timezone': employee.timezone,
                    'clientId': employee.clientId
                }
            }
        })
    }

    onDelete = (employeeId) => {
        this.props.log('EmployeesByTeam.js/onDelete (employeeId)', employeeId);
        fetch('/api/employees/' + employeeId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editEmployee: { ...this.blankEmployee }
                    }, () => this.props.getEmployees());
                    this.props.addToast('Employee deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete employee.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancel = () => {
        this.props.log('EmployeesByTeam.js/handleCancel');
        this.setState({
            editEmployee: { ...this.blankEmployee },
        })
    }

    handleEdit = () => {
        this.props.log('EmployeesByTeam.js/handleEdit');
        fetch('/api/employees/' + this.state.editEmployee.employeeId, {
            method: 'PUT',
            body: JSON.stringify({
                firstName: this.state.editEmployee.firstName,
                lastName: this.state.editEmployee.lastName,
                email: this.state.editEmployee.email,
                jobTitle: this.state.editEmployee.jobTitle,
                role1: this.state.editEmployee.role1,
                role2: this.state.editEmployee.role2,
                teamMembership: this.state.editEmployee.teamMembership,
                active: this.state.editEmployee.active,
                startDate: this.state.editEmployee.startDate,
                exitDate: this.state.editEmployee.exitDate,
                location: this.state.editEmployee.location,
                startTime: this.state.editEmployee.startTime,
                endTime: this.state.editEmployee.endTime,
                employeeNumber: this.state.editEmployee.employeeNumber,
                departments: this.state.editEmployee.departments,
                timezone: this.state.editEmployee.timezone,
                clientId: this.props.clientId
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editEmployee: { ...this.blankEmployee }
                    }, () => this.props.getEmployees());
                    this.props.addToast('Employee updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update employee.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAdd = (e) => {
        this.props.log('EmployeesByTeam.js/handleAdd');
        fetch('/api/employees/', {
            method: 'POST',
            body: JSON.stringify({
                firstName: this.state.newEmployee.firstName,
                lastName: this.state.newEmployee.lastName,
                email: this.state.newEmployee.email,
                jobTitle: this.state.newEmployee.jobTitle,
                role1: this.state.newEmployee.role1,
                role2: this.state.newEmployee.role2,
                teamMembership: this.state.newEmployee.teamMembership,
                active: this.state.newEmployee.active,
                startDate: this.state.newEmployee.startDate,
                exitDate: this.state.newEmployee.exitDate,
                location: this.state.newEmployee.location,
                startTime: this.state.newEmployee.startTime,
                endTime: this.state.newEmployee.endTime,
                employeeNumber: this.state.newEmployee.employeeNumber,
                departments: this.state.newEmployee.departments,
                timezone: this.state.newEmployee.timezone,
                clientId: this.props.clientId
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newEmployee: { ...this.blankEmployee }
                    }, () => this.props.getEmployees());
                    this.props.addToast('Employee added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add employee.', 5, 'success')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getJobTitles = () => {
        this.props.info('EmployeesByTeam.js/getJobTitles');
        return (
            <>
                <option value="0">Select Job Title</option>
                <option>SBOC</option>
                <option>BOC</option>
                <option>JBOC</option>
                <option>BOM</option>
                <option>ABOM</option>
                <option>Business Analyst</option>
                <option>Contractor</option>
                <option>Developer</option>
                <option>Other</option>
            </>
        )
    }

    getTimezones = () => {
        this.props.info('EmployeesByTeam.js/getTimezones');
        return (
            <>
                <option value="0">Select Timezone</option>
                <option>Eastern Standard Time</option>
                <option>Central Standard Time</option>
                <option>Mountain Standard Time</option>
                <option>Pacific Standard Time</option>
                <option>UTC-08</option>
            </>
        )
    }

    getTeamMemberships = () => {
        this.props.info('EmployeesByTeam.js/getTeamMemberships');
        return (
            <>
                <option value="0">Select Team Membership</option>
                {this.props.teams.filter(team => team.active).map(team => (
                    <option key={team.id} value={team.id}>{team.teamName}</option>
                ))}
            </>
        )
    }

    getRoles = (num) => {
        this.props.info('EmployeesByTeam.js/getRoles');
        return (
            <>
                <option value="0">Select Role #{num}</option>
                <option>Team Leader</option>
                <option>Assistant Team Leader</option>
                <option>Corporate Actions</option>
                <option>Director of Back Office</option>
                <option>Other</option>
            </>
        )
    }

    standardRow = (employee) => {
        this.props.info('EmployeesByTeam.js/standardRow (employee)', employee);
        return (
            <Row className={"adminRow " + (this.checkPermission('Edit Employees') ? "pointer" : "")} onClick={() => this.checkPermission('Edit Employees') ? this.onEdit(employee.employeeId) : null}>
                <Col md={4} className="text-left">
                    <FontAwesomeIcon icon={(employee['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((employee['active']) ? 'iconActive' : 'iconInactive')} />
                    {employee['firstName'] + " " + employee['lastName']}
                </Col>
                <Col md={4} className="text-left">{employee['jobTitle']}</Col>
                <Col md={4} className="text-left">{[employee['role1'], employee['role2']].filter(item => item != null & item !== '').join(', ')}</Col>
            </Row>
        )
    }

    editRow = (employee) => {
        this.props.log('EmployeesByTeam.js/editRow (employee)', employee);
        return (
            <Row className="editRow adminRow activeTab">
                <Col md={8}>
                    <Row>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">First Name</Label>
                            <Input
                                placeholder="First Name"
                                type="text"
                                id="employee-edit-firstName"
                                name="firstName"
                                value={this.props.isFieldNull(this.state.editEmployee.firstName)}
                                onChange={e => this.onChange(e, 'edit')} />
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Last Name</Label>
                            <Input
                                placeholder="Last Name"
                                type="text"
                                id="employee-edit-lastName"
                                name="lastName"
                                value={this.props.isFieldNull(this.state.editEmployee.lastName)}
                                onChange={e => this.onChange(e, 'edit')} />
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Email</Label>
                            <Input
                                placeholder="Email"
                                type="text"
                                id="employee-edit-email"
                                name="email"
                                value={this.props.isFieldNull(this.state.editEmployee.email)}
                                onChange={e => this.onChange(e, 'edit')} />
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Job Title</Label>
                            <Input
                                placeholder="Job Title"
                                type="select"
                                id="employee-edit-jobTitle"
                                name="jobTitle"
                                value={this.props.isFieldNull(this.state.editEmployee.jobTitle)}
                                onChange={e => this.onChange(e, 'edit')} >
                                {this.getJobTitles()}
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Role 1</Label>
                            <Input
                                placeholder="Role 1"
                                type="select"
                                id="employee-edit-role1"
                                name="role1"
                                value={this.props.isFieldNull(this.state.editEmployee.role1)}
                                onChange={e => this.onChange(e, 'edit')} >
                                {this.getRoles(1)}
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Role 2</Label>
                            <Input
                                placeholder="Role 2"
                                type="select"
                                id="employee-edit-role2"
                                name="role2"
                                value={this.props.isFieldNull(this.state.editEmployee.role2)}
                                onChange={e => this.onChange(e, 'edit')} >
                                {this.getRoles(2)}
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Start Date</Label>
                            <Input
                                placeholder="Start Date"
                                type="date"
                                id="employee-edit-startDate"
                                name="startDate"
                                value={this.props.isFieldNull(this.state.editEmployee.startDate)}
                                onChange={e => this.onChange(e, 'edit')} >
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Exit Date</Label>
                            <Input
                                placeholder="Exit Date"
                                type="date"
                                id="employee-edit-exitDate"
                                name="exitDate"
                                value={this.props.isFieldNull(this.state.editEmployee.exitDate)}
                                onChange={e => this.onChange(e, 'edit')} >
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Team Membership</Label>
                            <Input
                                placeholder="Team Membership"
                                type="select"
                                id="employee-edit-teamMembership"
                                name="teamMembership"
                                value={this.props.isFieldNull(this.state.editEmployee.teamMembership)}
                                onChange={e => this.onChange(e, 'edit')} >
                                {this.getTeamMemberships()}
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Start Time</Label>
                            <Input
                                placeholder="Start Time"
                                type="time"
                                id="employee-edit-startTime"
                                name="startTime"
                                value={this.props.isFieldNull(this.state.editEmployee.startTime)}
                                onChange={e => this.onChange(e, 'edit')} >
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">End Time</Label>
                            <Input
                                placeholder="End Time"
                                type="time"
                                id="employee-edit-endTime"
                                name="endTime"
                                value={this.props.isFieldNull(this.state.editEmployee.endTime)}
                                onChange={e => this.onChange(e, 'edit')} >
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Employee Number</Label>
                            <Input
                                placeholder="Employee Number"
                                type="text"
                                id="employee-edit-employee-number"
                                name="employeeNumber"
                                value={this.props.isFieldNull(this.state.editEmployee.employeeNumber)}
                                onChange={e => this.onChange(e, 'edit')} >
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Location</Label>
                            <Input
                                placeholder="Location"
                                type="text"
                                id="employee-edit-location"
                                name="location"
                                value={this.props.isFieldNull(this.state.editEmployee.location)}
                                onChange={e => this.onChange(e, 'edit')} >
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Timezone</Label>
                            <Input
                                type="select"
                                id="employee-edit-timezone"
                                name="timezone"
                                value={this.props.isFieldNull(this.state.editEmployee.timezone)}
                                onChange={e => this.onChange(e,'edit')} >
                                {this.getTimezones()}
                            </Input>
                        </Col>
                    </Row>
                </Col>
                <Col md={4} className="text-left">
                    <Row>
                        <Col>
                            <Label className="mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Departments</Label>
                            <div className='ml-3 mt-1'>

                                {this.props.departments.map(department => (
                                    <FormGroup row key={department.id} className="py-0 my-0">
                                        <Label
                                            for={"employee-edit-departments_" + department.id}
                                            className='pl-4 py-0 my-0'
                                        >
                                            <Input
                                                type="checkbox"
                                                id={"employee-edit-departments_" + department.id}
                                                name={"departments"}
                                                checked={this.props.isFieldNull(String(this.state.editEmployee.departments).split(',').findIndex(d => parseInt(d) === parseInt(department.id)) > -1, true)}
                                                onChange={e => this.onChange(e, 'edit')} />
                                            {department.departmentName}
                                        </Label>
                                    </FormGroup>
                                ))}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Label
                                for="employee-edit-active"
                                className='pl-4 mt-3'
                            >
                                <Input
                                    type="checkbox"
                                    id="employee-edit-active"
                                    name="active"
                                    checked={this.props.isFieldNull(this.state.editEmployee.active, true)}
                                    onChange={e => this.onChange(e, 'edit')} />
                                Active
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit Employee">
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                            <ConfirmButton className="mx-3" color="danger" onClick={() => this.onDelete(employee.employeeId)} title="Delete Employee">
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </ConfirmButton>
                            <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    addRow = () => {
        this.props.info('EmployeesByTeam.js/addRow');
        return (<Form className='px-3'>
            <Row className="mainRow mt-4">
                <h3 className='text-left mt-3 mb-2 mx-0 px-0'>Add New Employee</h3>
            </Row>
            <Row>
                <Col md={8}>
                    <Row>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">First Name</Label>
                            <Input
                                placeholder="First Name"
                                type="text"
                                id="employee-add-firstName"
                                name="firstName"
                                value={this.props.isFieldNull(this.state.newEmployee.firstName)}
                                onChange={e => this.onChange(e)} />
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Last Name</Label>
                            <Input
                                placeholder="Last Name"
                                type="text"
                                id="employee-add-lastName"
                                name="lastName"
                                value={this.props.isFieldNull(this.state.newEmployee.lastName)}
                                onChange={e => this.onChange(e)} />
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Email</Label>
                            <Input
                                placeholder="Email"
                                type="text"
                                id="employee-add-email"
                                name="email"
                                value={this.props.isFieldNull(this.state.newEmployee.email)}
                                onChange={e => this.onChange(e)} />
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Job Title</Label>
                            <Input
                                placeholder="Job Title"
                                type="select"
                                id="employee-add-jobTitle"
                                name="jobTitle"
                                value={this.props.isFieldNull(this.state.newEmployee.jobTitle)}
                                onChange={e => this.onChange(e)} >
                                {this.getJobTitles()}
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Role 1</Label>
                            <Input
                                placeholder="Role 1"
                                type="select"
                                id="employee-add-role1"
                                name="role1"
                                value={this.props.isFieldNull(this.state.newEmployee.role1)}
                                onChange={e => this.onChange(e)} >
                                {this.getRoles(1)}
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Role 2</Label>
                            <Input
                                placeholder="Role 2"
                                type="select"
                                id="employee-add-role2"
                                name="role2"
                                value={this.props.isFieldNull(this.state.newEmployee.role2)}
                                onChange={e => this.onChange(e)} >
                                {this.getRoles(2)}
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Start Date</Label>
                            <Input
                                placeholder="Start Date"
                                type="date"
                                id="employee-add-startDate"
                                name="startDate"
                                value={this.props.isFieldNull(this.state.newEmployee.startDate)}
                                onChange={e => this.onChange(e)} >
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Exit Date</Label>
                            <Input
                                placeholder="Exit Date"
                                type="date"
                                id="employee-add-exitDate"
                                name="exitDate"
                                value={this.props.isFieldNull(this.state.newEmployee.exitDate)}
                                onChange={e => this.onChange(e)} >
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Team Membership</Label>
                            <Input
                                placeholder="Team Membership"
                                type="select"
                                id="employee-add-teamMembership"
                                name="teamMembership"
                                value={this.props.isFieldNull(this.state.newEmployee.teamMembership)}
                                onChange={e => this.onChange(e)} >
                                {this.getTeamMemberships()}
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Start Time</Label>
                            <Input
                                placeholder="Start Time"
                                type="time"
                                id="employee-add-startTime"
                                name="startTime"
                                value={this.props.isFieldNull(this.state.newEmployee.startTime)}
                                onChange={e => this.onChange(e)} >
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">End Time</Label>
                            <Input
                                placeholder="End Time"
                                type="time"
                                id="employee-add-endTime"
                                name="endTime"
                                value={this.props.isFieldNull(this.state.newEmployee.endTime)}
                                onChange={e => this.onChange(e)} >
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Employee Number</Label>
                            <Input
                                placeholder="Employee Number"
                                type="text"
                                id="employee-add-employee-number"
                                name="employeeNumber"
                                value={this.props.isFieldNull(this.state.newEmployee.employeeNumber)}
                                onChange={e => this.onChange(e)} >
                            </Input>
                        </Col>
                        <Col md={3} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Location</Label>
                            <Input
                                placeholder="Location"
                                type="text"
                                id="employee-add-location"
                                name="location"
                                value={this.props.isFieldNull(this.state.newEmployee.location)}
                                onChange={e => this.onChange(e)} >
                            </Input>
                        </Col>
                        <Col md={6} className="px-1">
                            <Label className="float-left mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Timezone</Label>
                            <Input
                                type="select"
                                id="employee-add-timezone"
                                name="timezone"
                                value={this.props.isFieldNull(this.state.newEmployee.timezone)}
                                onChange={e => this.onChange(e)} >
                                {this.getTimezones()}
                            </Input>
                        </Col>
                    </Row>
                </Col>
                <Col md={4} className="text-left">
                    <Row>
                        <Col>
                            <Label className="mb-0 mp-1 ml-2 mt-1 font-weight-bold text-secondary">Departments</Label>
                            <div className='ml-3 mt-1'>

                                {this.props.departments.map(department => (
                                    <FormGroup row key={department.id} className="py-0 my-0">
                                        <Label
                                            for={"employee-departments_" + department.id}
                                            className='pl-4 py-0 my-0'
                                        >
                                            <Input
                                                type="checkbox"
                                                id={"employee-departments_" + department.id}
                                                name={"departments"}
                                                checked={this.props.isFieldNull(String(this.state.newEmployee.departments).split(',').findIndex(d => parseInt(d) === parseInt(department.id)) > -1, true)}
                                                onChange={e => this.onChange(e)} />
                                            {department.departmentName}
                                        </Label>
                                    </FormGroup>
                                ))}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Label
                                for="employee-edit-active"
                                className='pl-4 mt-3'
                            >
                                <Input
                                    type="checkbox"
                                    id="employee-active"
                                    name="active"
                                    checked={this.props.isFieldNull(this.state.newEmployee.active, true)}
                                    onChange={e => this.onChange(e)} />
                                Active
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button disabled={this.state.newEmployee.firstName === '' || this.state.newEmployee.lastName === '' || this.state.newEmployee.email === ''} color="primary" onClick={this.handleAdd}>Add Employee</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Form>
        )
    }

    render() {
        this.props.info('EmployeesByTeam.js/render');
        const employees = this.props.employees != null ?
            this.props.employees
            : [];
        return (
            <Container fluid>
                {this.props.teams.filter(team => team.active).map(team => {
                    const teamEmployees = employees.filter(employee => parseInt(employee.teamMembership) === team.id && employee.active);
                    return (
                        <Fragment key={team.id}>
                            <h3 className="text-left mt-5 mb-2">{team.teamName}</h3>
                            {teamEmployees.length > 0 ? teamEmployees.map(employee => (
                                <Fragment key={employee.employeeId}>{this.state.editEmployee.employeeId === employee.employeeId ? this.editRow(employee) : this.standardRow(employee)}</Fragment>
                            )
                            ) : <Row><Col md={12} className="text-left">No Team Members Assigned</Col></Row>
                            }
                        </Fragment>
                    )
                })}
                {employees.findIndex(employee => employee.teamMembership === '') > -1 || employees.findIndex(employee => parseInt(employee.teamMembership) === 0) > -1 ?
                    <><h3 className="text-left mt-5 mb-2">Team Not Assigned</h3>
                        {employees.filter(employee => (employee.teamMembership === '' || parseInt(employee.teamMembership) === 0) && employee.active).map(employee => (
                            <Fragment key={employee.employeeId}>{this.state.editEmployee.employeeId === employee.employeeId ? this.editRow(employee) : this.standardRow(employee)}</Fragment>
                        ))}</>
                    : null}
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Employees">
                    {
                        this.addRow()
                    }
                </PermissionWrapper>
            </Container>
        );
    }
}

export default EmployeesByTeam;